import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Label } from '@/components/ui/Label';
import type { DriverLanguage } from '@/lib/types';

interface LanguagesSelectorProps {
  value: DriverLanguage[];
  onChange: (next: DriverLanguage[]) => void;
  disabled?: boolean;
}

const ALL_LANGUAGES: DriverLanguage[] = ['urdu', 'arabic', 'english'];

export function LanguagesSelector({ value, onChange, disabled = false }: LanguagesSelectorProps) {
  const { t } = useTranslation();

  const toggle = (lang: DriverLanguage) => {
    if (value.includes(lang)) {
      onChange(value.filter((l) => l !== lang));
    } else {
      onChange([...value, lang]);
    }
  };

  return (
    <div className="space-y-1.5">
      <Label>{t('drivers.field.languages')}</Label>
      <div className="grid grid-cols-3 gap-2">
        {ALL_LANGUAGES.map((lang) => {
          const selected = value.includes(lang);
          return (
            <button
              key={lang}
              type="button"
              onClick={() => toggle(lang)}
              disabled={disabled}
              className={`flex items-center justify-center gap-1.5 p-2.5 rounded-md border text-sm font-medium transition-all ${
                selected
                  ? 'border-gold bg-gold/10 text-foreground'
                  : 'border-border text-muted-foreground hover:text-foreground hover:border-muted-foreground/40'
              }`}
            >
              {selected && <Check className="h-3.5 w-3.5 text-gold" />}
              {t(`drivers.languages.${lang}`)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
